import axios from "axios";
import { baseUrl } from "./config";
import { encodeBody, encodeQueryParams } from "./client";

export const getClubLicence: any = (params: any) => {
  const path = `/api/clubs/${params.id}/licence-cycles/current`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
  })
    .then(response => response.data.data)
    .catch(err => {
      console.error('error while fetching data in getClubLicence', err);
    })
};

export const getLicenceSaCriteria: any = (params: any) => {
  const path = `${baseUrl}/api/licence/criteria/clubs/${params.clubId}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },

  }).then(res => res.data.data).catch(err => {
    console.error('error while fetching data in getLicenceSaCriteria', err)
  })
}

export const getLicenceCriteria: any = (params: any) => {
  const path = `${baseUrl}/api/licenceReviews/clubs/${params.clubId}/criteria`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },

  }).then(res => res.data.data).catch(err => {
    console.error('error while fetching data in getLicenceCriteria', err)
  })
}

export const getLicenceSaCriteriaStandards: any = (params: any) => {
  const path = `${baseUrl}/api/licence/standards/criteria/${params.criteriaId}/clubs/${params.clubId}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },

  }).then(res => res.data.data).catch(err => {
    console.error('error while fetching data in getLicenceSaCriteriaStandards', err)
  })
}

export const getLicenceCriteriaStandards: any = (params: any) => {
  const path = `${baseUrl}/api/licenceReviews/clubs/${params.clubId}/criteria/${params.criteriaId}/standards`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },

  }).then(res => res.data.data).catch(err => {
    console.error('error while fetching data in getLicenceCriteriaStandards', err)
  })
}

export const getLicenceStandardsMetadata: any = (params: any) => {
  const path = `${baseUrl}/api/licence/standards/${params.standardsId}/actionStandard`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },

  }).then(res => res.data.data).catch(err => {
    console.error('error while fetching data in getLicenceStandardsMetadata', err)
  })
}

export const getLicenceStandardsAction: any = (params: any) => {
  const path = `${baseUrl}/api/licence/standards/${params.standardId}/clubs/${params.clubId}/actions${encodeQueryParams(params)}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },

  }).then(res => res.data.data).catch(err => {
    console.error('error while fetching data in getLicenceStandardsAction', err)
  })
}

export const getLicenceStandardsEvidences: any = (params: any) => {
  const path = `${baseUrl}/api/evidence/licence/standards/${params.standardId}/clubs/${params.clubId}${encodeQueryParams(params)}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },

  }).then(res => res.data.data).catch(err => {
    console.error('error while fetching data in getLicenceStandardsEvidences', err)
  })
}

export const getLicenceStandardsSAComments: any = (params: any) => {
  const path = `${baseUrl}/api/licenceReviews/clubs/${params.clubId}/standards/${params.standardsId}/selfAssessmentComment`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },

  }).then(res => res.data.data).catch(err => {
    console.error('error while fetching data in getLicenceStandardsSAComments', err)
  })
}

export const getLicenceStandardsEvaluation: any = (params: any) => {
  const path = `${baseUrl}/api/licenceReviews/clubs/${params.clubId}/standards/${params.standardId}/evaluation`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },

  }).then(res => res.data.data).catch(err => {
    console.error('error while fetching data in getLicenceStandardsEvaluation', err)
  })
}

export const saveLicenceStandardsEvaluation: any = (params: any) => {
  const path = `${baseUrl}/api/licenceReviews/clubs/${params.clubId}/standards/${params.standardId}/evaluation`;
  return axios({
    method: 'POST',
    data: encodeBody(params.data),
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },

  }).then(res => res.data.data).catch(err => {
    console.error('error while fetching data in saveLicenceStandardsEvaluation', err)
  })
}

export const saveLicenceStandardsSa: any = (params: any) => {
  const path = `${baseUrl}/api/licenceReviews/selfAssessmentComment`;
  return axios({
    method: 'POST',
    data: encodeBody(params),
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },

  }).then(res => res.data.data).catch(err => {
    console.error('error while fetching data in saveLicenceStandardsEvaluation', err)
  })
}

export const getStandardListByClubLicence: any = (params: any) => {
  const path = `${baseUrl}/api/licence/standards/clubs/${params.clubId}${encodeQueryParams({
    criterionId: params.criterionId,
  })}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data).catch(err => {
    console.error('error while fetching data in getStandardListByClubLicence', err)
  });
};

export const getLicenceCriterias: any = (params: any) => {
  return axios({
    method: 'GET',
    url: `${baseUrl}/api/licence/criteria/clubs/${params.clubId}`,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

export const updateActionsLicence: any = (params: any) => {
  const path = `${baseUrl}/api/actions/clubs/${params.clubId}/licence/standards/${params.standardId}`;
  return axios({
    method: 'POST',
    url: path,
    data: encodeBody(params.actions),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};


export const evidenceToStandardLicence: any = (params: any) => {
  const path = `${baseUrl}/api/evidence/licence/standards`;
  return axios({
    method: 'PUT',
    url: path,
    data: encodeBody(params),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

export const getLicenceCriteriaComments: any = (params: any) => {
  const path = `${baseUrl}/api/licence/criteria/clubs/${params.clubId}/comments/${params.criteriaId}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

export const saveLicenceCriteriaComments: any = (params: any) => {
  const path = `${baseUrl}/api/licence/criteria/updateCriteriaComments/${params.id}`;
  return axios({
    method: 'POST',
    url: path,
    data: encodeBody(params.data),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};


export const getLicecnePhaseProgress: any = (params: any) => {
  const path = `${baseUrl}/api/licence/criteria/clubs/${params.clubId}/criteriaProgress/${params.criteriaId}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

export const getLicenceCriteriaCommentsHistory: any = (params: any) => {
  const path = `${baseUrl}/api/licence/criteria/clubs/${params.clubId}/commentsHistory/${params.criteriaId}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

// --------------- Licence Dashboard -------------------------------

export const getLicenseCompanyDetails = (params:any) => {
  const path = `${baseUrl}/api/LicenceDashboard/licence/companyDetails${encodeQueryParams(params)}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

export const getLicenseFinance = (params:any) => {
  const path = `${baseUrl}/api/LicenceDashboard/licence/finance${encodeQueryParams(params)}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

export const getLicenseFacilityExplore = (params:any) => {
  const path = `${baseUrl}/api/LicenceDashboard/licence/Facility${encodeQueryParams(params)}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

export const getLicenseTeamsExplore = (params:any) => {
  const path = `${baseUrl}/api/LicenceDashboard/licence/Teams${encodeQueryParams(params)}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};
export const getSupportFundExplore = (params:any) => {
  const path = `${baseUrl}/api/LicenceDashboard/licence/supportfund${encodeQueryParams(params)}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};
export const getStaffResponse = (params:any) => {
  const path = `${baseUrl}/api/LicenceDashboard/licence/staff${encodeQueryParams(params)}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};
export const getPlayersExplore = (params:any) => {
  const path = `${baseUrl}/api/LicenceDashboard/licence/Players${encodeQueryParams(params)}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};
export const getPlayersCount = (params:any) => {
  const path = `${baseUrl}/api/LicenceDashboard/licence/PlayersCount${encodeQueryParams(params)}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};
export const getFacilitiesResponse = (params:any) => {
  const path = `${baseUrl}/api/LicenceDashboard/licence/Facility${encodeQueryParams(params)}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

// ---------------------------------------RESTRICTIONS

export const getCriteriaRestrictionsLicence: any = ({ clubId, criteriaId }:any) => {
  const path = `${baseUrl}/api/licence/criteria/clubs/${clubId}/restrictions/${criteriaId}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

// ---------------------------------------

export const getStandardRestrictionsLicence: any = ({ clubId, standardId }:any) => {
  const path = `${baseUrl}/api/licence/standards/clubs/${clubId}/restrictions/${standardId}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

// ---------------------------------------

export const restrictCriteriaUsersLicence: any = ({ clubId, criteriaId, users }:any) => {
  const path = `${baseUrl}/api/licence/criteria/clubs/${clubId}/restrictions/${criteriaId}`;
  return axios({
    method: 'POST',
    url: path,
    data: users,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};

// ---------------------------------------

export const restrictStandardUsersLicence: any = ({ clubId, standardId, users }:any) => {
  const path = `${baseUrl}/api/licence/standards/clubs/${clubId}/restrictions/${standardId}`;
  return axios({
    method: 'POST',
    url: path,
    data: users,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.data.data);
};